<div
    class="flex flex-row"
    xmlns="http://www.w3.org/1999/html">
    <div class="relative flex justify-center pb-2">
        @if (!(isAvatar() && isDefaultImage())) {
            <img
                alt="Image selected"
                class="aspect-square object-contain w-32"
                [src]="imageUrl()" />
        } @else {
            <div class="w-30 h-30 flex items-center justify-center fa-5x">
                <fa-layers class="fa-2x">
                    <fa-icon
                        class="text-custom-light-blue"
                        [icon]="['fas', 'circle']" />
                    <fa-icon
                        class="text-custom-blue"
                        transform="shrink-4"
                        [icon]="['fas', 'user']" />
                </fa-layers>
            </div>
        }
        <div
            class="absolute top-2 right-2 bg-custom-grey rounded-full w-7 h-7 flex items-center justify-center cursor-pointer">
            <input
                #image
                class="hidden"
                type="file"
                [accept]="acceptedImageExtensions"
                [multiple]="false"
                (change)="updateImage(image.files)" />
            <fa-icon
                class="text-custom-blue"
                size="sm"
                [icon]="['fas', 'pen']"
                (click)="image.click()" />
        </div>
        <div
            class="absolute bottom-2 right-2 bg-custom-grey rounded-full w-7 h-7 flex items-center justify-center cursor-pointer">
            <fa-icon
                class="text-custom-blue"
                size="sm"
                [icon]="['fas', 'trash']"
                (click)="updateImage(null)" />
        </div>
    </div>
</div>
